import styled from 'styled-components';
import Image from '@stencil/image';

export const CenterDiv = styled.div`
  display: flex;
  align-items: center;
  ${props =>
    props.fixedHeight &&
    `
      margin-top: 1.5rem;
      height: 25px;
    `}
`;

export const SpotlightContainer = styled.div`
  padding: 1rem 0 0.5rem;
`;

export const CoupleFriendlyTagContainer = styled.div(
  props => `
`,
);

export const HotelNameAndAddressContainer = styled.div`
  width: 500px;
`;

export const HotelNameAndAddressAndReviewWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ReviewInfoContainer = styled.div`
  width: 305px;
  margin-top: 1rem;
  ${props => props.isAltAcco && `margin-right: -1rem;`}
`;

export const Wrapper = styled.div`
  width: ${props => (props?.expand ? '100%' : 'auto')};
`;

export const IndiannessIcon = styled(Image)`
  margin-left: 0.8rem;
  height: 1.9rem;
`;

export const StarRatingContainer = styled.div`
  border: 1px solid #e4e4e4;
  border-radius: 0.4rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  width: 7rem;
  justify-content: center;
`;

export const Dot = styled.div`
  margin-right: 0.3rem;
`;

export const RatingOuterWrapper = styled.div`
  margin-right: 1.5rem;
`;
